const isDevelopment = process.env.NODE_ENV === 'development';

export const getBaseUrl = () => {
  if (isDevelopment) {
    return '';
  }
  
  return '/scheduler';
};

// Get the basename for the Router component
export const getRouterBasename = () => {
  return getBaseUrl();
};

// Get the full URL for direct redirects (window.location.href)
export const getFullUrl = (path: string) => {
  const baseUrl = getBaseUrl();
  // Remove leading slash if it exists to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${baseUrl}/${cleanPath}`;
};

export const createPath = (path: string) => {
  const baseUrl = getBaseUrl();
  // Remove leading slash if it exists to avoid double slashes
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${baseUrl}/${cleanPath}`;
}; 